import React from "react"

import classNames from "classnames"

import { WithClassName } from "shared/types/WithClassName"
import { LoadingSpinner } from "shared/ui/loading-spinner/LoadingSpinner"

interface ProductConfiguratorLoadingStepProps extends WithClassName {}

export const ProductConfiguratorLoadingStep = React.memo(
  ({ className }: ProductConfiguratorLoadingStepProps) => {
    return (
      <div
        className={classNames("product-configurator-loading-step", className)}
      >
        <div className="product-configurator-loading-step__loader">
          <LoadingSpinner />
        </div>
      </div>
    )
  }
)
